import type React from 'react'
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import type { PropertiesPanelReasonTag } from '@/lib/panels/properties-panel-applicability'
import type { PropertiesPanelSectionId } from '@/lib/panels/types/properties-panel-section-id'
import { SectionReasonTag } from './section-reason-tag'

interface PropertiesSectionProps {
  value: PropertiesPanelSectionId
  label: string
  reason: PropertiesPanelReasonTag | null
  /** See `SelectToolProps.registerSectionElement`. */
  registerSectionElement?: (id: PropertiesPanelSectionId, el: HTMLDivElement | null) => void
  children: React.ReactNode
}

/** One collapsible properties-panel section: a muted header carrying the section label and its
 *  reason tag, over the section's panel. */
export function PropertiesSection({
  value,
  label,
  reason,
  registerSectionElement,
  children,
}: PropertiesSectionProps) {
  return (
    <AccordionItem
      value={value}
      className="border-none"
      ref={(el) => registerSectionElement?.(value, el)}
    >
      <AccordionTrigger className="py-2 px-2 rounded-md text-sm font-normal leading-none text-foreground bg-muted/70 hover:bg-muted/80 [&>svg]:text-foreground hover:no-underline">
        <span className="flex items-center gap-2">
          {label}
          <SectionReasonTag reason={reason} />
        </span>
      </AccordionTrigger>
      <AccordionContent className="pt-3 pb-0 px-1">{children}</AccordionContent>
    </AccordionItem>
  )
}
